export { default as StrategyItem } from './StrategyItem';
